// Keep direct links across login, accepting only destinations within this app.
export function postLoginPath(path: string | null | undefined): string {
    if (!path?.startsWith('/')) return '/'
    const origin = 'https://dashboard.a-grid.com'
    try {
        const url = new URL(path, origin)
        if (url.origin !== origin || url.pathname === '/login') return '/'
        return `${url.pathname}${url.search}${url.hash}`
    } catch {
        return '/'
    }
}

export function loginUrl(path: string): string {
    const destination = postLoginPath(path)
    return destination === '/' ? '/login' : `/login?redirect=${encodeURIComponent(destination)}`
}
